import React, {Fragment} from 'react';
import Select from './../Select';
import isEqual from 'lodash-es/isEqual';
import {set, get} from '../../../utils/dotutils';
import PickPackPoint from './pickpackpoint';
import PersonalPickUp from './personalpickup';
import PropTypes from 'prop-types';
import Booklog from "./booklog_shipping";
import FurgeFutar from "./furgefutar";
import FurgeFutarPoint from "./furgefutarpoint";
import ExternalShipping from "./external_shipping";

class ShippingControl extends React.Component {

    static propTypes = {
        required: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        value: PropTypes.any,
        fields: PropTypes.array,
        layout: PropTypes.any,
    }

    setFieldValue = (field, value)  => {
        if (field === undefined) {
            this.props.saveChanges(this.props.name, {...value});
        } else {
            let oldValue = get(this.props.value, field);
            if (!isEqual(oldValue, value)) {
                const v = {...this.props.value};
                set(v, field, value);
                this.props.saveChanges(this.props.name, v);
            }
        }
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled || props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        const serviceprovider_type = <div className="col-md-12">
            <Select
                {...this.getProps("serviceprovider_type")}
                name={"serviceprovider_type"}
                autoSelect={true}
                component="ShippingServiceProvider"
                storeType="local"
                labelKey="methodname"
                valueKey="id"
                objectValue={false}
                options={this.props.availableProviders}
                value={this.props.value && this.props.value.serviceprovider_type}
                saveChanges={(name, value) => this.setFieldValue("serviceprovider_type", value)}
                label="Szállító"
                required={this.props.required === true || (Array.isArray(this.props.required) && this.props.required.indexOf("serviceprovider_type") !== -1)}
            />
        </div>;
        return {
            serviceprovider_type
        }
    }

    getLayout = () => {
        const fields = this.getFields();
        let MethodParams = null;
        if (this.props.value) {
            if (this.props.value.serviceprovider_type === 'pickpackpoint') {
                MethodParams = PickPackPoint;
            } else if (this.props.value.serviceprovider_type === 'personalpickup') {
                MethodParams = PersonalPickUp;
            } else if (this.props.value.serviceprovider_type === 'booklog_shipping') {
                MethodParams = Booklog;
            } else if (this.props.value.serviceprovider_type === 'furgefutar') {
                MethodParams = FurgeFutar;
            } else if (this.props.value.serviceprovider_type === 'furgefutarpoint') {
                MethodParams = FurgeFutarPoint;
            } else if (this.props.value.serviceprovider_type === 'external_shipping') {
                MethodParams = ExternalShipping;
            }
        }
        if (MethodParams) {
            MethodParams = <MethodParams
                required={this.props.required}
                {...this.getProps(this.props.name)}
                value={this.props.value || null}
                client={this.props.client}
                layout={this.props.layout}
                linkShippingAddress={this.props.linkShippingAddress}
                autoFill={this.props.autoFill}
                fields={fields}
                saveChanges={(field, value) => this.setFieldValue(field, value)}
            />
        } else {
            return this.props.layout ? this.props.layout(fields) : fields.serviceprovider_type;
        }
        return MethodParams;
    }

    render() {
        return this.getLayout();
    }

}

export default ShippingControl;